var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"slideshow",staticClass:"slideshow"},_vm._l((_vm.content),function(slide,i){return _c('img',{key:`slide${i}`,staticClass:"carousel-cell",attrs:{"src":slide.sizes.large}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }